import React from 'react';

const JumboLayoutFooterContext = React.createContext({});

export default JumboLayoutFooterContext;
